import { orderedOnboardingSteps } from '../../Onboarding/helpers/onboardingSteps'

const signUpUrl = '/candidate/signup'
const onboardingUrlParts = [...orderedOnboardingSteps, 'confirm-details']
const onboardedUrlParts = [
  'interview_requests',
  'dashboard',
  'job-search',
  'personal-information',
  'preferred-salary',
  'ideal-job',
  'work-authorisation',
  'preferred-location',
  'online-profiles',
  'preferred-roles',
  'top-skills',
  'work-history',
  'education',
  'about-me',
  'projects',
  'uploaded-files',
  'blocked-companies',
]

// Filter out paths with the same name in onboarded views
const onboardingOnlyUrlParts = onboardingUrlParts.filter(part => !onboardedUrlParts.includes(part))

const onboardingOnlyUrlPathnames = candidateId => [
  ...onboardingOnlyUrlParts.map(part => `/candidate/${candidateId}/${part}`),
  // temporary redirects: remove after 01/09/2022
  ...onboardingUrlParts.map(part => `/candidate/${part}`),
  signUpUrl,
]

export const isOnboardingOnlyRoute = (candidateId, currentPathname) =>
  onboardingOnlyUrlPathnames(candidateId).some(name => currentPathname.includes(name))

const unprotectedRoutes = [signUpUrl, '/candidate/social-auth', '/']
export const isProtectedRoute = currentPathname => {
  return !unprotectedRoutes.includes(currentPathname)
}

/**
 * Base URL of the new candidate profile app. Used to redirect from the old profile page.
 * Set REACT_APP_NEW_CANDIDATE_PROFILE_APP_URL to override (e.g. in CI).
 * @returns {string}
 */
export const getNewCandidateProfileAppBaseUrl = () => {
  if (process.env.REACT_APP_NEW_CANDIDATE_PROFILE_APP_URL) {
    return process.env.REACT_APP_NEW_CANDIDATE_PROFILE_APP_URL.replace(/\/$/, '')
  }
  const env = process.env.REACT_APP_ENVIRONMENT
  if (env === 'staging') return 'https://candidate.staging.offerzen.com'
  if (env === 'development') return 'http://localhost:5173'
  return 'https://candidate.offerzen.com'
}

/**
 * Full URL for the new candidate profile page (same profileId as this app).
 * @param {string} profileId - Candidate profile ID (or slug)
 * @returns {string}
 */
export const getNewCandidateProfileUrl = profileId =>
  `${getNewCandidateProfileAppBaseUrl()}/candidate/${encodeURIComponent(profileId)}/profile`
